KCVS.Views.ReportAgreementRowTable =
  template: JST['report_rows/agreement_rows_table']()

  mounted: ->
    @fetchAgreementRows()

  data: ->
    rows: []

  components:
    'informative-tooltip': KCVS.Views.InformativeTooltip

  methods:
    updateRow: (row) ->
      arrayRow = _.find(@rows, (s_row) -> s_row.id == row.id )
      oldRowIndex = _.indexOf(@rows, arrayRow)
      @rows[oldRowIndex] = row

    destroyRow: (row) ->
      arrayRow = _.find(@rows, (s_row) -> s_row.id == row.id )
      deletedRowIndex = _.indexOf(@rows, arrayRow)
      if deletedRowIndex >= 0
        @rows.splice(deletedRowIndex, 1)

    fetchAgreementRows: ->
      $.ajax
        url: "/admin/project_partners/#{@.$root.projectPartnerId}/report_agreement_rows.json"
        method: 'GET'
        dataType: 'JSON'
        success: (data) =>
          @rows = data
